module.exports = __webpack_public_path__ + "media/assets/images/campaigns/image-video-ftc-271c849739652f3e023f083fc0d6d9dc.png";